import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { makeServer } from "./server";
import { AuthProvider, NoteProvider, FilterProvider } from "./contexts/contexts";
import { BrowserRouter } from "react-router-dom";

// Call make Server
makeServer();

ReactDOM.render(
<React.StrictMode>
  <BrowserRouter>
    <FilterProvider>
      <AuthProvider>
        <NoteProvider>          
          <App />
        </NoteProvider>
      </AuthProvider>
    </FilterProvider>
  </BrowserRouter>
</React.StrictMode>,
  document.getElementById("root")
);
